module.exports = __webpack_public_path__ + "static/media/DC_O_Embroidery_Bicocca_White_Orange.1408676e.png";